import React from 'react';
import config from 'config';
import splashSports from 'assets/images/CBS_sports_splash_logo.svg';
import splashNews from 'assets/images/CBS_news_splash_logo.svg';

const splashSrc = config.buildBrandId === 'cbs-news' ? splashNews : splashSports;

const BrandSplashImage: React.FC = () => (
  <img
    className="w-100 h-100"
    data-testid="splash-image"
    src={splashSrc}
    alt=""
  />
);

export default BrandSplashImage;
